import React from 'react';
import { string, bool, func, arrayOf } from 'prop-types';
import s from './Modal.module.scss';

const Modal = ({ isOpen, onClose, title, text }) => {
  return (
    <div className={isOpen ? s.modal : s.modalHidden}>
      <div className={s.modalScroll}>
        <div className={s.modalContent}>
          <div className={s.modalContentHeader}>
            <i
              className={s.modalCloseIcon}
              onClick={onClose}
            />
          </div>
          <div className={s.modalContentText}>
            <h1>{title}</h1>
            {text && text.map((textItem, id) => <p key={id}>{textItem}</p>)}
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: bool,
  onClose: func,
  title: string,
  text: arrayOf(string),
};

export default Modal;
